export default __webpack_public_path__ + "static/media/team41.c3b2d5a9.JPG";